import React from 'react'
import { isMobile } from 'react-device-detect'
import { useTranslation } from '../hooks/useTranslation'

export const GuideToUse = () => {
  const { t } = useTranslation()
  return isMobile ? (
    <>
      {' '}
      <div className="w-[335px] h-auto p-[40px]  bg-[#E7F9F7] flex flex-col items-center gap-[10px] border rounded-[20px] mt-[40px] px-5 py-8">
        <div className="flex flex-col items-center gap-[4px]">
          <p className="text-[#2E343D] font-bold leading-[28.8px] text-center text-[20px] md:text-[24px]">
            {t('guideToUse.title')}
          </p>
          <p className="text-main text-[12px] font-bold">
            {t('guideToUse.subtitle')}
          </p>
        </div>
        <div className=" w-full flex flex-col gap-6 items-start text-base">
          <p className="flex gap-[10px] items-center">
            <img
              src="/assets/img/logo/coupang.png"
              alt="youtube icon"
              className="w-[43.93px] h-[44.36px]"
            />
            <div className="flex flex-col ">
              <a
                href="https://blog.fastseller.shop/coupangpartnersguide/"
                target="_blank"
                rel="noreferrer"
                className="font-bold"
              >
                {t('guideToUse.guides.coupang.title')}
              </a>
              <p className="text-[14px]">
                {t('guideToUse.guides.coupang.description')}
              </p>
            </div>
          </p>
          <p className="flex gap-[10px] items-center ">
            <img
              src="/assets/img/logo/ali.png"
              alt="youtube icon"
              className="w-[43.93px] h-[44.36px]"
            />
            <div className="flex flex-col ">
              <a
                href="https://blog.fastseller.shop/aliexpressaffiliatteguide/"
                target="_blank"
                rel="noreferrer"
                className="font-bold"
              >
                {t('guideToUse.guides.ali.title')}
              </a>
              <p className="text-[14px]">{t('guideToUse.guides.ali.description')}</p>
            </div>
          </p>
          <p className="flex gap-[10px] items-center">
            <img
              src="/assets/img/logo/shorts.png"
              alt="youtube icon"
              className="w-[43.93px] h-[44.36px]"
            />
            <div className="flex flex-col ">
              <a
                href="https://blog.fastseller.shop/youtubeshortsupload/"
                target="_blank"
                rel="noreferrer"
                className=" font-bold"
              >
                {t('guideToUse.guides.shorts.title')}
              </a>
              <p className="text-[14px]">{t('guideToUse.guides.shorts.description')}</p>
            </div>
          </p>
          <p className="flex gap-[10px] font-bold">
            <img
              src="/assets/img/logo/premium.png"
              alt="youtube icon"
              className="w-[43.93px] h-[44.36px]"
            />
            <div className="flex flex-col ">
              <a
                href="https://blog.fastseller.shop/paeseuteukeosai-peuro-peurimieom-gaideu/"
                target="_blank"
                rel="noreferrer"
                className=" font-bold"
              >
                {t('guideToUse.guides.premium.title')}
              </a>
              <p className="text-[14px] font-normal">
                {t('guideToUse.guides.premium.description')}
              </p>
            </div>
          </p>
          <p className="flex gap-[10px] items-center">
            <img
              src="/assets/img/logo/youtube.png"
              alt="youtube icon"
              className="w-[43.93px] h-[44.36px]"
            />
            <div className="flex flex-col ">
              <a
                href="https://blog.fastseller.shop/fastcutai_youtube_upload_guide/"
                target="_blank"
                rel="noreferrer"
                className=" font-bold"
              >
                {t('guideToUse.guides.youtube.channelAuth.title')}
              </a>
              <p className="text-[14px] font-normal">
                {t('guideToUse.guides.youtube.channelAuth.description')}
              </p>
            </div>
          </p>
          <p className="flex gap-[10px] items-center">
            <img
              src="/assets/img/logo/youtube.png"
              alt="youtube icon"
              className="w-[43.93px] h-[44.36px]"
            />
            <div className="flex flex-col ">
              <a
                href="https://blog.fastseller.shop/youtubeadvancedverification/"
                target="_blank"
                rel="noreferrer"
                className="font-bold"
              >
                {t('guideToUse.guides.youtube.advanced.title')}
              </a>
              <p className="text-[14px] font-normal">
                {t('guideToUse.guides.youtube.advanced.description')}
              </p>
            </div>
          </p>
          <p className="flex gap-[10px] font-bold">
            <img
              src="/assets/img/logo/fastcut.png"
              alt="youtube icon"
              className="w-[43.93px] h-[44.36px]"
            />
            <div className="flex flex-col ">
              <a
                href="https://blog.fastseller.shop/"
                target="_blank"
                rel="noreferrer"
                className=" font-bold"
              >
                {t('guideToUse.guides.fastcut.title')}
              </a>
              <p className="text-[14px] font-normal">
                {t('guideToUse.guides.fastcut.description')}
              </p>
            </div>
          </p>
          <p className="flex gap-[10px] font-bold">
            <img
              src="/assets/img/logo/light.png"
              alt="youtube icon"
              className="w-[43.93px] h-[44.36px]"
            />
            <div className="flex flex-col ">
              <a
                href="https://blog.fastseller.shop/youtubeuploadguide/"
                target="_blank"
                rel="noreferrer"
                className=" font-bold"
              >
                {t('guideToUse.guides.light.title')}
              </a>
              <p className="text-[14px] font-normal">
                {t('guideToUse.guides.light.description')}
              </p>
            </div>
          </p>
        </div>
      </div>
    </>
  ) : (
    <>
      <div className="w-full h-auto p-[40px]  bg-[#E7F9F7] flex flex-col items-center gap-[10px] border rounded-[20px] mt-[40px]">
        <div className="flex flex-col items-center gap-[4px]">
          <p className="text-[#2E343D] font-bold leading-[28.8px] text-center text-[18px] md:text-[24px]">
            {t('guideToUse.title')}
          </p>
          <p className="text-main text-[10px] md:text-[18px] font-bold">
            {t('guideToUse.subtitle')}
          </p>
        </div>
        <div className="w-[660px] flex justify-between">
          <div className="flex flex-col gap-[16px]">
            <p className="flex gap-[10px] items-center">
              <img
                src="/assets/img/logo/coupang.png"
                alt="youtube icon"
                className="w-[43.93px] h-[44.36px]"
              />
              <div className="flex flex-col ">
                <a
                  href="https://blog.fastseller.shop/coupangpartnersguide/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[10px] md:text-base font-bold"
                >
                  {t('guideToUse.guides.coupang.title')}
                </a>
                <p className="text-[14px]">
                  {t('guideToUse.guides.coupang.description')}
                </p>
              </div>
            </p>
            <p className="flex gap-[10px] items-center ">
              <img
                src="/assets/img/logo/ali.png"
                alt="youtube icon"
                className="w-[43.93px] h-[44.36px]"
              />
              <div className="flex flex-col ">
                <a
                  href="https://blog.fastseller.shop/aliexpressaffiliatteguide/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[10px] md:text-base font-bold"
                >
                  {t('guideToUse.guides.ali.title')}
                </a>
                <p className="text-[14px]">{t('guideToUse.guides.ali.description')}</p>
              </div>
            </p>
            <p className="flex gap-[10px] items-center">
              <img
                src="/assets/img/logo/shorts.png"
                alt="youtube icon"
                className="w-[43.93px] h-[44.36px]"
              />
              <div className="flex flex-col ">
                <a
                  href="https://blog.fastseller.shop/youtubeshortsupload/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[10px] md:text-base font-bold"
                >
                  {t('guideToUse.guides.shorts.title')}
                </a>
                <p className="text-[14px]">{t('guideToUse.guides.shorts.description')}</p>
              </div>
            </p>
            <p className="flex gap-[10px] font-bold">
              <img
                src="/assets/img/logo/premium.png"
                alt="youtube icon"
                className="w-[43.93px] h-[44.36px]"
              />
              <div className="flex flex-col ">
                <a
                  href="https://blog.fastseller.shop/paeseuteukeosai-peuro-peurimieom-gaideu/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[10px] md:text-base font-bold"
                >
                  {t('guideToUse.guides.premium.title')}
                </a>
                <p className="text-[14px] font-normal">
                  {t('guideToUse.guides.premium.description')}
                </p>
              </div>
            </p>
          </div>
          <div className="flex flex-col gap-[16px]">
            <p className="flex gap-[10px] items-center">
              <img
                src="/assets/img/logo/youtube.png"
                alt="youtube icon"
                className="w-[43.93px] h-[44.36px]"
              />
              <div className="flex flex-col ">
                <a
                  href="https://blog.fastseller.shop/fastcutai_youtube_upload_guide/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[10px] md:text-base font-bold"
                >
                  {t('guideToUse.guides.youtube.channelAuth.title')}
                </a>
                <p className="text-[14px] font-normal">
                  {t('guideToUse.guides.youtube.channelAuth.description')}
                </p>
              </div>
            </p>
            <p className="flex gap-[10px] items-center">
              <img
                src="/assets/img/logo/youtube.png"
                alt="youtube icon"
                className="w-[43.93px] h-[44.36px]"
              />
              <div className="flex flex-col ">
                <a
                  href="https://blog.fastseller.shop/youtubeadvancedverification/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[10px] md:text-base font-bold"
                >
                  {t('guideToUse.guides.youtube.advanced.title')}
                </a>
                <p className="text-[14px] font-normal">
                  {t('guideToUse.guides.youtube.advanced.description')}
                </p>
              </div>
            </p>
            <p className="flex gap-[10px] font-bold">
              <img
                src="/assets/img/logo/fastcut.png"
                alt="youtube icon"
                className="w-[43.93px] h-[44.36px]"
              />
              <div className="flex flex-col ">
                <a
                  href="https://blog.fastseller.shop/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[10px] md:text-base font-bold"
                >
                  {t('guideToUse.guides.fastcut.title')}
                </a>
                <p className="text-[14px] font-normal">
                  {t('guideToUse.guides.fastcut.description')}
                </p>
              </div>
            </p>
            <p className="flex gap-[10px] font-bold">
              <img
                src="/assets/img/logo/light.png"
                alt="youtube icon"
                className="w-[43.93px] h-[44.36px]"
              />
              <div className="flex flex-col ">
                <a
                  href="https://blog.fastseller.shop/youtubeuploadguide/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[10px] md:text-base font-bold"
                >
                  {t('guideToUse.guides.light.title')}
                </a>
                <p className="text-[14px] font-normal">
                  {t('guideToUse.guides.light.description')}
                </p>
              </div>
            </p>
          </div>
        </div>
      </div>
    </>
  )
}
